var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTiles = function SvgTiles(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    viewBox: "0 0 13 13",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tiles_svg__a",
    width: 13,
    height: 13,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "tiles_svg__b",
    width: 13,
    height: 13,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#tiles_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13v13H0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.9v-1.4c0-.9-.2-1.1-1.1-1.1h-1.4c-.9 0-1.1.2-1.1 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m0-4.7V5.8c0-.9-.2-1.1-1.1-1.1h-1.4c-.9 0-1.1.2-1.1 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m0-4.7V1.1c0-.9-.2-1.1-1.1-1.1h-1.4c-.9 0-1.1.2-1.1 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m-4.7 9.4v-1.4c0-.9-.2-1.1-1.1-1.1H5.8c-.9 0-1.1.2-1.1 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m0-4.7V5.8c0-.9-.2-1.1-1.1-1.1H5.8c-.9 0-1.1.2-1.1 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m0-4.7V1.1C8.3.2 8.1 0 7.2 0H5.8c-.9 0-1.1.2-1.1 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m-4.7 9.4v-1.4c0-.9-.2-1.1-1.1-1.1H1.1c-.9 0-1.1.2-1.1 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m0-4.7V5.8c0-.9-.2-1.1-1.1-1.1H1.1C.2 4.7 0 4.9 0 5.8v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1m0-4.7V1.1C3.6.2 3.4 0 2.5 0H1.1C.2 0 0 .2 0 1.1v1.4c0 .9.2 1.1 1.1 1.1h1.4c.9 0 1.1-.2 1.1-1.1",
    style: {
      mask: "url(#tiles_svg__b)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTiles);
export default ForwardRef;